import { useGlobalConfig } from 'context/GlobalContext';
import React, { useState } from 'react';
import { Image, Modal, Pressable, Text, TouchableWithoutFeedback, View } from 'react-native';
import theme from 'theme';

import { Icons } from 'components/Icons';

const BandMoreMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { BandMoreTab } = useGlobalConfig();

  const handleSelect = (productUrl: string) => {
    window.open(productUrl, '_self');
    setIsOpen(false);
  };

  return (
    <>
      {/* Trigger button */}
      <Pressable
        onPress={() => setIsOpen(true)}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          borderWidth: 2,
          borderColor: '#B5B5B5',
          borderRadius: 999,
          paddingVertical: 2,
          paddingHorizontal: 4,
          width: 90,
        }}
        accessibilityLabel="Mais opções do menu">
        <Icons.Plus width={14} height={14} stroke="currentColor" style={{ color: '#B4B6C1' }} />
        <Text
          style={{
            color: '#B4B6C1',
            fontSize: 16,
            fontFamily: theme.fonts.inter.regular,
          }}>
          Band
        </Text>
      </Pressable>

      {/* Dropdown menu */}
      <Modal
        visible={isOpen}
        transparent
        animationType="fade"
        onRequestClose={() => setIsOpen(false)}>
        <TouchableWithoutFeedback onPress={() => setIsOpen(false)}>
          <View
            style={{
              flex: 1,
              backgroundColor: 'rgba(0,0,0,0.3)',
              justifyContent: 'flex-start',
              alignItems: 'flex-end',
              paddingTop: 50,
              paddingRight: 20,
            }}>
            <View
              style={{
                minWidth: 200,
                gap: 10,
                paddingTop: 8,
                paddingRight: 10,
                paddingBottom: 10,
                borderRadius: 4,
                marginTop: 12,
                marginRight: 30,
                backgroundColor: '#15161C',
              }}>
              {BandMoreTab?.product.map((data) => (
                <Pressable
                  key={data.productUrl}
                  onPress={() => handleSelect(data.productUrl)}
                  style={({ focused, hovered }: any) => ({
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: 12,
                    marginLeft: 10,
                    backgroundColor: focused || hovered ? '#333336' : 'transparent',
                  })}>
                  <Image
                    source={{ uri: data.productImage.url }}
                    alt={data.productImage.title}
                    style={{
                      width: data.productImage.width,
                      height: data.productImage.height,
                      resizeMode: 'contain',
                    }}
                  />
                </Pressable>
              ))}
            </View>
          </View>
        </TouchableWithoutFeedback>
      </Modal>
    </>
  );
};

export default BandMoreMenu;
